import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="product-suggestion"
export default class extends Controller {
static values = { source: String, newLineItemUrl: String }
static targets = ["input", "template", "emptyTemplate", "showMoreTemplate", "pleaseWait", "substitutionTemplate"]

  connect() {
    const options = {
      minLength: 3,
      debug: false,
      autoselect: false
    };

    const dataSet = {
      name: "remote",
      displayKey: "reference",    
      source: (query, cb) => {
        return $.get(this.sourceValue, {query}, data => cb(data.options, data.meta));
      },
      templates: {
        suggestion: (object, forwarded_args) => {
          let template = this.templateTarget.innerHTML
            .replace("{{id}}", object.id)
            .replace("{{active_sku}}", object.reference)
            .replace("{{designation}}",object.designation);
  
          let substitution_text = "";
    
          template = template.replace("{{id}}", object.id);
          if (object.is_substitute) {
            substitution_text = this.substitutionTemplateTarget.innerHTML
          }
    
          return template.replace("{{substitution_marker}}", substitution_text);
        },
        empty: (context, forwardedArgs) => {
          if (!forwardedArgs.more) {
            return null;
          }

          return this.emptyTemplateTarget.innerHTML.replace('{{url}}', forwardedArgs.more)
        },
        footer: (context, forwardedArgs) => {
          if (forwardedArgs.more && !context.isEmpty) {
            return this.showMoreTemplateTarget.innerHTML.replace('{{url}}', forwardedArgs.more)
          }
          return null;
        }
      }
    }

    this.autocomplete = $(this.inputTarget).autocomplete(options, dataSet).bind('autocomplete:selected', (event, suggestion, dataset) => this.fetchNewLineItem(suggestion))

    this.dispatch('autocomplete-created', {})
  }

  select(event) {
    event.preventDefault()
    this.fetchNewLineItem({id: null, reference: this.autocomplete.autocomplete("val")})
  }
  
  fetchNewLineItem({id, reference}) {
    const data = { 
      purchase_order_item: {
        product_id: id,
        searched_product_reference: reference
      }
    };

    const url = this.newLineItemUrlValue;

    const ajaxConfig = {
      url,
      data,
      beforeSend: (jqXHR, settings) => {
        if (this.hasPleaseWaitTarget) {
          this.pleaseWaitTarget.classList.remove('hidden')
        }
      },
      success: (data, textStatus, jqXHR) => {
        // Fix for #1250
        // As redirects are automatically followed, use a custom header instead
        if (jqXHR.getResponseHeader("X-AUTOCOMPLETE-REDIRECT")) {
          window.location = jqXHR.getResponseHeader("X-AUTOCOMPLETE-REDIRECT");
          return;
        }
  
        this.autocomplete.autocomplete('destroy')
        
        this.element.outerHTML = data;
      }
    };
    
    return $.ajax(ajaxConfig);
  }
}
